import { ApiError } from '@alpha/api-client';
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // The api-client already handles 401 (refresh once, then redirect) and
        // 419 (re-mint CSRF cookie, replay). Retrying auth/permission/validation
        // failures here would only duplicate work.
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
